import { TeamLogoCombinedProps } from './types';

const usePresenter = (props: TeamLogoCombinedProps): TeamLogoCombinedProps => {
  return props;
};

export default usePresenter;
